import { render, staticRenderFns } from "./EmailEventItemModal.vue?vue&type=template&id=941bac34&"
import script from "./EmailEventItemModal.vue?vue&type=script&lang=ts&"
export * from "./EmailEventItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports